// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__rxQ_W","box":"styles_box__NNBl9","icon":"styles_icon__J_HmM"};